import { Power0, Power3 } from 'gsap'
import TimelineMax from 'gsap/TimelineMax'
// import { bindInViewTimelineStagger } from '../util/animations'

class ProductListed {
  constructor ($el, masterTimeline) {
    this.$el = $el
    // if (typeof $el.data('animateIn') === 'undefined' || $el.data('animateIn') === true) {
    //   this.timelineIn = new TimelineMax({ paused: true, onComplete: () => { this.$el.data('animateInDone', true) } })
    //   this.buildTimelineIn()
    //   bindInViewTimelineStagger($el, this.timelineIn, masterTimeline)
    // }
    this.timelineHover = new TimelineMax({ paused: true })
    this.buildTimelineHover()
  }

  // buildTimelineIn () {
  //   this.timelineIn
  //     .fromTo(this.$el.find('.product-listed__image'), 0.8, { x: '-100%' }, { x: '0%', ease: Power3.easeOut }, 0)
  //     .fromTo(this.$el.find('.bg'), 0.8, { x: '100%' }, { x: '0%', ease: Power3.easeOut }, 0)
  // }

  buildTimelineHover () {
    const $el = this.$el
    const $hover = $el.findElement('hover')
    this.timelineHover
      .to(
        $hover,
        0.4,
        { autoAlpha: 1, ease: Power0.easeNone }
      )
      .staggerFromTo(
        $hover.find('.meta').children(),
        0.4,
        {
          y: '20px',
          autoAlpha: 0,
        },
        {
          y: '0px',
          autoAlpha: 1,
          ease: Power3.easeInOut,
        },
        0.1,
        0.05
      )

    $el.data('timelineHover', this.timelineHover)
  }
}

export default ProductListed



// WEBPACK FOOTER //
// ./scripts/components/ProductRelatedListed.js